var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({attrs:{"label":_vm.$t('Commission on tax'),"hide-details":"auto"},model:{value:(_vm.commissionOnTax),callback:function ($$v) {_vm.commissionOnTax=$$v},expression:"commissionOnTax"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }